export default "__VITE_ASSET__oLqH48JT__"